import React from "react";
import { Link } from "react-router-dom";
import { Trophy, Users, Clock, Gem, Crown } from "lucide-react";

const fmt = (n) => Number(n || 0).toLocaleString("en-IN");

export default function ContestCard({ contest }) {
  const isLive = contest.status === "live";
  const isUpcoming = contest.status === "upcoming";
  const end = new Date(contest.end_date);
  const ms = end - new Date();
  const days = Math.max(0, Math.floor(ms / (1000 * 60 * 60 * 24)));
  const hours = Math.max(0, Math.floor((ms / (1000 * 60 * 60)) % 24));
  const preview = contest.payout_preview || {};
  const entry = contest.entry_fee || 0;
  const top1 = preview.top1_credits || 0;
  const pool = preview.projected_prize_pool || 0;
  return (
    <Link
      to={`/contests/${contest.contest_id}`}
      data-testid={`contest-card-${contest.contest_id}`}
      className="block rounded-3xl overflow-hidden glass card-hover"
    >
      <div className="relative h-32 overflow-hidden">
        <img src={contest.image_url} alt={contest.name} className="w-full h-full object-cover opacity-80" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, transparent 30%, rgba(5,5,8,0.95))" }} />
        <div className="absolute top-3 left-3 flex items-center gap-2">
          <span className="chip" style={{ background: isLive ? "#00FF6622" : "#B026FF22", color: isLive ? "#00FF66" : "#B026FF", border: `1px solid ${isLive ? "#00FF6655" : "#B026FF55"}` }}>
            {isLive ? "● Live" : isUpcoming ? "Upcoming" : "Ended"}
          </span>
          <span className="chip" style={{ background: "#00F0FF15", color: "#00F0FF", border: "1px solid #00F0FF44" }}>
            {contest.mode === "standard" ? contest.category : contest.mode}
          </span>
        </div>
        <div className="absolute bottom-3 left-3 right-3">
          <p className="font-display text-xl font-bold leading-tight">{contest.name}</p>
          <p className="text-xs text-white/60 mt-0.5 line-clamp-1">{contest.tagline}</p>
        </div>
      </div>

      {/* Entry vs Earn — the headline economics */}
      <div className="px-4 pt-3 pb-2 grid grid-cols-2 gap-2">
        <div className="rounded-xl px-3 py-2" style={{ background: "rgba(255,214,0,0.08)", border: "1px solid rgba(255,214,0,0.25)" }} data-testid="card-entry-fee">
          <p className="text-[9px] tracking-widest uppercase text-[#FFD600]/80 font-bold">Entry</p>
          <p className="font-display text-base font-bold text-[#FFD600] leading-tight">
            {entry === 0 ? "Free" : `${fmt(entry)}`}
          </p>
          <p className="text-[10px] text-white/50">Fanpuff Credits</p>
        </div>
        <div className="rounded-xl px-3 py-2" style={{ background: "rgba(0,255,102,0.08)", border: "1px solid rgba(0,255,102,0.25)" }} data-testid="card-top1-prize">
          <p className="text-[9px] tracking-widest uppercase text-[#00FF66]/85 font-bold flex items-center gap-1"><Crown className="w-2.5 h-2.5" /> #1 Wins up to</p>
          <p className="font-display text-base font-bold text-[#00FF66] leading-tight">{fmt(top1)}</p>
          <p className="text-[10px] text-white/50">Pool ≈ {fmt(pool)}</p>
        </div>
      </div>

      <div className="px-4 pb-3 flex items-center justify-between text-xs text-white/60">
        <span className="inline-flex items-center gap-1"><Users className="w-3.5 h-3.5" /> {fmt(contest.current_entries)}</span>
        <span className="inline-flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {days}d {hours}h</span>
        <span className="inline-flex items-center gap-1 text-[#FFD600] font-semibold">
          <Trophy className="w-3.5 h-3.5" /> Build Circle & win
        </span>
      </div>
    </Link>
  );
}
